export const API_BASE_URL = 'https://api.talkali.com';
export const APPLE_APP_URL = 'https://apps.apple.com/us/app/talkali/id6761047725';
export const ANDROID_APP_URL = 'https://play.google.com/store/apps';
export const WEB_APP_URL = 'https://app.talkali.com/';
export const PAYPAL_POPUP_PATH = '/paypal-checkout';